import styled from 'styled-components'

const ProcessFlowStep = styled.div`
  font-family: NeueHaasUnica, sans-serif;
  display: table-cell;
  text-align: center;
  vertical-align: top;
  font-weight: bold;
`

const ProcessFlowStepIcon = styled.span`
  display: block;
  width: 26px;
  height: 28px;
  background-color: #d7d7d7;
  border-radius: 50%;
  border: solid 3px  #979797;
  margin: 0 auto .5em;
  position: relative;
`

const ProcessFlowStepLabel = styled.span`
  display: block;
  margin: 3% auto;
  font-size: 0.875em;
  color: #000000;
  padding: 5% .25em 5;
  line-height: normal;
`

const SrOnly = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
`

type ProgressStepProps = {
  label: string
  cssClass: string
  ariaLabel: string
}

const ProgressStep = ({ label, cssClass, ariaLabel }: ProgressStepProps) => (
  <ProcessFlowStep id={`${label}`} className={`${cssClass}`}>
    <ProcessFlowStepIcon aria-label={ariaLabel} className="process-flow-step-icon">
      <SrOnly>{label}</SrOnly>
    </ProcessFlowStepIcon>
    <ProcessFlowStepLabel className="process-flow-step-label">{label}</ProcessFlowStepLabel>
  </ProcessFlowStep>
)

export { ProgressStep }
